import PerfectScrollbar from 'perfect-scrollbar';
import throttle from 'lodash.throttle';

const stickyNavigation = () => {
  document.body.classList.toggle('top-nav', window.scrollY < 20);
};

export function initHeaderScroll() {
  const $header = document.querySelector('header');

  if (!$header) {
    return;
  }

  stickyNavigation();

  window.addEventListener('scroll', throttle(() => {
    stickyNavigation();
  }, 250));
}

export function initBurgerButton() {
  const burger = document.querySelector('.js-btn-burger');

  const ps = new PerfectScrollbar('.js-container-nav-mobile');

  burger.addEventListener('click', () => {
    document.body.classList.toggle('menu-opened');
    ps.update();
  });
}
